import React, { useState, useRef, useEffect } from "react"
import { AppFunctionComponent, TextBuilder } from "../../../types"
import { PromoBarContainer } from "./promo-bar.styled"
import Section from "../../../components/common/sections/section.component"
import RichText from "../../../resolvers/rich-text/rich-text.resolver"
import Modal, { ModalType } from "../modal/modal.component"

type Props = {
  content?: TextBuilder
}

const PromoBar: AppFunctionComponent<Props> = ({ content }) => {
  const { text } = content!
  const [isNewsletterPopupOpen, setIsNewsletterPopupOpen] = useState(false)
  const [isNewsletterSigningFinished, setIsNewsletterSigningFinished] =
    useState(false)

  const promoBarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = promoBarRef.current
    if (!container) return

    const anchors = container.querySelectorAll("a")
    const handleClick = (e: MouseEvent) => {
      const target = e.currentTarget as HTMLAnchorElement
      if (
        target.textContent?.toLowerCase().includes("Zapisz się") ||
        target.textContent?.toLowerCase().includes("off") ||
        target.href?.toLowerCase().includes("discount")
      ) {
        e.preventDefault()
        setIsNewsletterPopupOpen(true)
      }
    }

    anchors.forEach((anchor) => {
      anchor.addEventListener("click", handleClick)
    })

    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener("click", handleClick)
      })
    }
  }, [text])

  const handleNewsletterSigningFinished = () => {
    setIsNewsletterSigningFinished(true)
  }

  return (
    <>
      {text && (
        <>
          <Modal
            active={isNewsletterPopupOpen}
            onClose={() => {
              setIsNewsletterPopupOpen(false)
            }}
            modalType={ModalType.NewsletterPopup}
            isNewsletterSigningFinished={isNewsletterSigningFinished}
            setIsNewsletterSigningFinished={handleNewsletterSigningFinished}
          />
          <PromoBarContainer ref={promoBarRef}>
            <Section>
              <RichText content={text} />
            </Section>
          </PromoBarContainer>
        </>
      )}
    </>
  )
}

export default PromoBar
